jQuery(document).ready(function ($) {
    // First Slider (Amount Slider)
    const amountPrevbtn = document.querySelector('#amount-prev');
    const amountNextbtn = document.querySelector('#amount-next');

    const amountRangeValue = document.querySelector('#amount-slider');
    const monthRangeValue = document.querySelector('#month-slider');
    const applyNowButton = document.querySelector('#apply-now-button');

    const amountTooltip = document.querySelector('#amount-tooltip');
    const monthTooltip = document.querySelector('#month-tooltip');

    const amountTitle = document.querySelector('#slider-title-amount');
    const monthTitle = document.querySelector('#slider-title-month');

    const weekAmount = document.querySelector('#week-amount');
    const fortnightPayment = document.querySelector('#fornight-amount');
    const monthAmount = document.querySelector('#month-amount');
    const totalRepaymentAmount = document.querySelector('#total-repayment-amount');
    const establishmentAmount = document.querySelector('#establishment-fee');
    const monthlyFeeAmount = document.querySelector('#monthly-fee');
    const interestRateText = document.querySelector('#interest-rate');
    const interestFeeText = document.querySelector('#interest-fee');


    function updateAmountTooltip(value) {
        if (!amountRangeValue || !amountTooltip) return; // Check if elements exist

        amountTooltip.textContent = `$${value}`;
        
        if (amountTitle) {
            amountTitle.textContent = value;
        }
        
        const sliderWidth = amountRangeValue.offsetWidth;
        const thumbWidth = 16; 
        const min = parseInt(amountRangeValue.min, 10);
        const max = parseInt(amountRangeValue.max, 10);
        const relativeValue = (value - min) / (max - min); 
        const tooltipOffset = (sliderWidth - thumbWidth) * relativeValue + thumbWidth / 2;
    
        amountTooltip.style.left = `${tooltipOffset}px`;
        amountTooltip.style.display = 'block';
    
        // Show or hide loan sections based on the value
        if (value <= 2000) {
            document.getElementById('loan_under_2000').style.display = 'block';
            document.getElementById('loan_above_2000').style.display = 'none';
        } else {
            document.getElementById('loan_under_2000').style.display = 'none';
            document.getElementById('loan_above_2000').style.display = 'block';
        }
        
        const monthlyFeeDiv = document.getElementById('monthlyFeeDiv');
        const interestFeeDiv = document.getElementById('interestFeeDiv');

        if (monthlyFeeDiv && interestFeeDiv) {
            if (value <= 2000) {
                monthlyFeeDiv.style.display = 'block';
                interestFeeDiv.style.display = 'none';
            } else {
                monthlyFeeDiv.style.display = 'none';
                interestFeeDiv.style.display = 'block';
            }
        }

        // Update the month slider range based on the amount value
        if (value > 2000) {
            monthRangeValue.min = 2;
            monthRangeValue.max = 24;
    
            if (monthRangeValue.value < 2 || monthRangeValue.value > 24) {
                if (monthRangeValue.value < 2) {
                    monthRangeValue.value = 2;
                } else if (monthRangeValue.value > 24) {
                    monthRangeValue.value = 24;
                }
            }
        } else {
            monthRangeValue.min = 2;
            monthRangeValue.max = 12;
    
            if (monthRangeValue.value < 2 || monthRangeValue.value > 12) {
                if (monthRangeValue.value < 2) {
                    monthRangeValue.value = 2;
                } else if (monthRangeValue.value > 12) {
                    monthRangeValue.value = 12;
                }
            }
        }
    
        updateMonthTooltip(monthRangeValue.value);
        updateInstallmentValues();
        updateApplyNowLink();
    }

    if (amountRangeValue) {
        amountRangeValue.addEventListener('input', () => {
            updateAmountTooltip(amountRangeValue.value);
        });
    }

    if (amountNextbtn) {
        amountNextbtn.addEventListener('click', () => {
            let currentValue = parseInt(amountRangeValue.value, 10);
            if (currentValue + 50 <= 5000) {
                amountRangeValue.value = currentValue + 50;
            } else {
                amountRangeValue.value = 5000;
            }
            updateAmountTooltip(amountRangeValue.value);
        });
    }

    if (amountPrevbtn) {
        amountPrevbtn.addEventListener('click', () => {
            let currentValue = parseInt(amountRangeValue.value, 10);
            if (currentValue - 50 >= 300) {
                amountRangeValue.value = currentValue - 50;
            } else {
                amountRangeValue.value = 300;
            }
            updateAmountTooltip(amountRangeValue.value);
        });
    }

    // Initialize tooltip position and value
    if (amountRangeValue) {
        updateAmountTooltip(amountRangeValue.value);
    }

    // Second Slider (Month Slider)
    const monthPrevbtn = document.querySelector('#month-prev');
    const monthNextbtn = document.querySelector('#month-next');

    function updateMonthTooltip(value) {
        if (!monthRangeValue || !monthTooltip) return; // Check if elements exist

        if (value == 1) {
            monthTooltip.textContent = `${value} month`;
            if (monthTitle) {
                monthTitle.textContent = `${value} month`;
            }
        } else {
            monthTooltip.textContent = `${value} months`;
            if (monthTitle) {
                monthTitle.textContent = `${value} months`;
            }
        }
        const sliderWidth = monthRangeValue.offsetWidth;
        const thumbWidth = 16; 
        const min = parseInt(monthRangeValue.min, 10);
        const max = parseInt(monthRangeValue.max, 10);
        const relativeValue = (value - min) / (max - min);
        const tooltipOffset = (sliderWidth - thumbWidth) * relativeValue + thumbWidth / 2;

        monthTooltip.style.left = `${tooltipOffset}px`;
        monthTooltip.style.display = 'block';
    }

    if (monthRangeValue) {
        monthRangeValue.addEventListener('input', () => {
            updateMonthTooltip(monthRangeValue.value);
            updateInstallmentValues();
            updateApplyNowLink();
        });
    }

    if (monthNextbtn) {
        monthNextbtn.addEventListener('click', () => {
            let currentValue = parseInt(monthRangeValue.value, 10);
            if (currentValue + 1 <= parseInt(monthRangeValue.max)) {
                monthRangeValue.value = currentValue + 1;
            } else {
                monthRangeValue.value = monthRangeValue.max;
            }
            updateMonthTooltip(monthRangeValue.value);
            updateInstallmentValues();
            updateApplyNowLink();
        });
    }

    if (monthPrevbtn) {
        monthPrevbtn.addEventListener('click', () => {
            let currentValue = parseInt(monthRangeValue.value, 10);
            if (currentValue - 1 >= parseInt(monthRangeValue.min)) {
                monthRangeValue.value = currentValue - 1;
            } else {
                monthRangeValue.value = monthRangeValue.min;
            }
            updateMonthTooltip(monthRangeValue.value);
            updateInstallmentValues();
            updateApplyNowLink();
        });
    }

    // Initialize month tooltip position and value
    if (monthRangeValue) {
        updateMonthTooltip(monthRangeValue.value);
    }

    // Calculation logic
    // function calculateInstallment(amount, termInMonth) {
    //     let weeklyPayment = 0;
    //     let monthlyPayment = 0;
    //     let totalRepayment = 0;
    //     let establishmentFee = 0;
    //     let monthlyFee = 0;
    //     let interestRate = 0;
    //     let interest = 0;

    //     if (amount <= 2000) {
    //         establishmentFee = amount * 0.2;
    //         monthlyFee = amount * 0.04;
    //         const totalMonthlyFee = termInMonth * monthlyFee;
    //         totalRepayment = amount + establishmentFee + totalMonthlyFee;
    //     } else {
    //         const principalAmount = amount;
    //         establishmentFee = 400;
    //         const loanAmount = principalAmount + establishmentFee;
    //         interest = 0.36 * loanAmount;
    //         interestRate = 36;
    //         totalRepayment = loanAmount + interest;
    //     }

    //     weekTerm = termInMonth * 4.33;
    //     weeklyPayment = totalRepayment / weekTerm;
    //     monthlyPayment = weeklyPayment * 4.33;

    //     const formatNumber = (value) => {
    //         return value % 1 === 0 ? value.toFixed(0) : value.toFixed(2);
    //     };

    //     return {
    //         weeklyPayment: formatNumber(parseFloat(weeklyPayment)),
    //         monthlyPayment: formatNumber(parseFloat(monthlyPayment)),
    //         totalRepayment: formatNumber(parseFloat(totalRepayment)),
    //         establishmentFee: formatNumber(parseFloat(establishmentFee)),
    //         monthlyFee: formatNumber(parseFloat(monthlyFee)),
    //         interestRate: interestRate,
    //         interestFee: formatNumber(parseFloat(interest)),
    //     };
    // }

   function calculateInstallment(amount) {
        let weeklyPayment = 0;
        let fortnightlyPayment = 0;
        let monthlyPayment = 0;
        let totalRepayment = 0;
        let establishmentFee = 0;
        let monthlyFee = 0;
        let interestRate = 0;
        let interest = 0;

        const formatNumber = (value) => {
            return value % 1 === 0 ? value.toFixed(0) : value.toFixed(2);
        };
        const termInMonth = parseInt(monthRangeValue.value, 10);
        const weeksInMonth = 4.33;
        const fortnightsInMonth = 2;

        if (amount <= 2000) {
            establishmentFee = amount * 0.2;
            monthlyFee = amount * 0.04;
            const totalMonthlyFee = termInMonth * monthlyFee;
            totalRepayment = amount + establishmentFee + totalMonthlyFee;
            monthlyPayment = totalRepayment / termInMonth;
            weeklyPayment = monthlyPayment / weeksInMonth;
            fortnightlyPayment = weeklyPayment * 2;
            interest = totalRepayment - amount - establishmentFee;
        } else {
            establishmentFee = 400;
            const loanAmount = amount + establishmentFee;
            interestRate = 0.36; // annual interest 36%
                  
            const weeksInYear = 52;
            const nw = (termInMonth / 12 * weeksInYear); // full weeks over term
            const rw = interestRate / weeksInYear;
            weeklyPayment = (loanAmount * rw) / (1 - Math.pow(1 + rw, -nw));     
                         
            const nf = (termInMonth / 12 * 26);
            const rf = interestRate / 26;            
            fortnightlyPayment = (loanAmount * rf) / (1 - Math.pow(1 + rf, -nf));

            const nm = termInMonth;
            const rm = interestRate / 12;        
            
            monthlyPayment = (loanAmount * rm) / (1 - Math.pow(1 + rm, -nm));
              
            totalRepayment = (weeklyPayment * nw);

            interest = totalRepayment - amount - establishmentFee;

            
        }

        return {
            weeklyPayment: formatNumber(weeklyPayment),
            fortnightlyPayment: formatNumber(fortnightlyPayment),
            monthlyPayment: formatNumber(monthlyPayment),
            totalRepayment: formatNumber(totalRepayment),
            establishmentFee: formatNumber(establishmentFee),
            monthlyFee: formatNumber(monthlyFee),
            interestRate: interestRate * 100, // as percent
            interestFee: formatNumber(interest),
        };
    }


    function updateInstallmentValues() {
        if (!amountRangeValue || !monthRangeValue) return; // Ensure sliders exist

        const amount = parseInt(amountRangeValue.value, 10);
        const termInMonth = parseInt(monthRangeValue.value, 10);

        const { weeklyPayment,fortnightlyPayment, monthlyPayment, totalRepayment, establishmentFee, monthlyFee, interestRate, interestFee } = calculateInstallment(amount, termInMonth);

        // Update the UI with the calculated values
        if(weekAmount){
            weekAmount.textContent = weeklyPayment;
        }

        if(fortnightPayment){
            fortnightPayment.textContent = fortnightlyPayment;
        }
        
        if(monthAmount){
            monthAmount.textContent = monthlyPayment;
        }

        if(totalRepaymentAmount){
            totalRepaymentAmount.textContent = totalRepayment;
        }

        if(establishmentAmount){
            establishmentAmount.textContent = establishmentFee;
        }

        if(monthlyFeeAmount){
            monthlyFeeAmount.textContent = monthlyFee;
        }

        if(interestRateText){
            interestRateText.textContent = interestRate;
        }

        if(interestFeeText){
            interestFeeText.textContent = interestFee;
        }
    }

    function updateApplyNowLink() {
        if (!amountRangeValue || !monthRangeValue || !applyNowButton) return; // Ensure all elements exist

        const amount = amountRangeValue.value;
        const month = monthRangeValue.value;

        // Get the base URL from the current href attribute
        const baseUrl = applyNowButton.href.split('?')[0];

        // Construct the new URL with query parameters
        const urlWithParams = `${baseUrl}?step=1&amount=${amount}&term=${month}`;

        // Update the href attribute of the button
        applyNowButton.href = urlWithParams;
    }

    // Initial calculation
    if (amountRangeValue && monthRangeValue) {
        updateInstallmentValues();
        updateApplyNowLink();
    }
});